import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 3v8.707","key":"svg-0"}],["path",{"d":"M8 14l-4 -4l4 -4","key":"svg-1"}],["path",{"d":"M18 21c0 -6.075 -4.925 -11 -11 -11h-3","key":"svg-2"}]]

const IconArrowRampLeft2 = createReactComponent('outline', 'arrow-ramp-left-2', 'ArrowRampLeft2', __iconNode);

export default IconArrowRampLeft2;